import {createFileRoute} from '@tanstack/react-router'
import {type} from 'arktype'

import searchParamString from '@/utils/schema/searchParamString'

const successSearchSchema = type({
  id: searchParamString,
})

export const Route = createFileRoute('/_food-grubhub/food/payment/success')({
  validateSearch: successSearchSchema,
})
